import { customGetAPI } from "./CustomAPI";

// FilterContext (column filters/sort) and useSavedHeaderViews (saved
// column-header views) both read the same per-user/submodule
// `filter-preference` record — they just pull different keys out of its
// filter_condition. On a screen using both, they mount within the same
// effect-commit tick, so without this they each fire their own identical GET
// before either has resolved. Cache the in-flight promise per key so the
// second caller reuses the first's request instead of duplicating it.
const inFlightRequests = new Map();

export const fetchFilterPreference = (domain, userId, subModuleId) => {
  const key = `${domain}|${userId}|${subModuleId}`;

  const existing = inFlightRequests.get(key);
  if (existing) return existing;

  const requestPromise = customGetAPI(
    `${domain}filter-preference/?user_id=${userId}&submodule_id=${subModuleId}`,
  ).finally(() => {
    inFlightRequests.delete(key);
  });

  inFlightRequests.set(key, requestPromise);
  return requestPromise;
};
